/**
 * Keep state of Sidebar
 */

import alt from 'components/Dispatcher';
import immutableStore from 'alt-utils/lib/ImmutableUtil';
import immutable from 'immutable';
import SidebarActions from 'actions/SidebarActions';

@immutableStore
class SidebarStore {
  constructor() {
    this.state = immutable.Map({
      open: false,
    });
    this.bindActions(SidebarActions);
  }

  /**
   * Update this.state to open the sidebar
   */
  onOpen() {
    const state = this.state.set('open', true);
    this.setState(state);
  }

  /**
   * Update this.state to close the sidebar
   */
  onClose() {
    const state = this.state.set('open', false);
    this.setState(state);
  }
}

export default alt.createStore(SidebarStore, 'SidebarStore');
